import React from 'react';
import { useNavigate } from 'react-router-dom';
import { IoIosArrowBack } from "react-icons/io";
import './BackButton.scss';

const BackButton = () => {
  const navigate = useNavigate();

  const goBack = () => navigate('/CopyMain'); // Replace with your target path

  // Use a wrapper for the text to make it center-aligned
  return (
    <div className="back-button">
      <IoIosArrowBack className="arrow" onClick={goBack}/>
      <span className="text" onClick={goBack}>order details</span>
    </div>
  );
};

export default BackButton;
